export default class TNSisuRefererUrl {
    static getRefererUrl() {
        let refererUrl = sessionStorage.getItem('tn:sisuRefererUrl');

        if (!refererUrl) {
            return null;
        }

        const regexIntlPath = /\/intl/i;
        const url = new URL(refererUrl, window.location.origin);
        return regexIntlPath.test(url.pathname) ? '/' + url.search : refererUrl;
    }

    static clearRefererUrl() {
        sessionStorage.removeItem('tn:sisuRefererUrl');
    }
}
